<template>
  <v-app>
    <v-slide-y-transition group tag="div" class="loan-container">
      <div v-if="request" class="content" key="content">
        <SectionWrapper
          title="사업 참여 신청서 작성"
          no-content
          v-if="!requestFileApplication || this.isFileEditable"
          :to="{ name: 'woori-crowd/detail/application', params: { uuid: this.uuid } }"
          subtitle="신청서 작성 후 서류제출이 가능합니다."
        >
        </SectionWrapper>

        <SectionWrapper title="제출 서류">
          <RequestFile
            :request="request"
            :uuid="uuid"
            :fileCategory="fileCategory"
            :requestFiles.sync="requestFiles"
            :disabled="!requestFileApplication"
          />
        </SectionWrapper>

        <SectionWrapper title="신청 내용" class="mb-5">
          <RequestSummary :request="request" />
        </SectionWrapper>
      </div>
    </v-slide-y-transition>
  </v-app>
</template>

<script>
import loansRequestApi from '@/api/now/loansRequestApi'
export default {
  props: ['uuid'],
  components: {
    RequestSummary: () => import('@/components/loans-request/detail/RequestSummary.vue'),
    RequestFile: () => import('@/components/loans-request/detail/RequestFile.vue'),
    SectionWrapper: () => import('@/components/loans-request/detail/SectionWrapper.vue'),
  },
  data() {
    return {
      ready: false,
      request: null,
      fileCategory: [
        { title: '국세완납증명서', required: true },
        { title: '지방세 완납증명서', required: true },
        { title: '소상공인 확인서', required: true },
        { title: '주민등록등본', required: true },
        { title: '주민등록초본', required: true, description: '변동이력 포함' },
        { title: '사업자등록증명원', required: true },
        { title: '온라인교육 수료증', required: true },
        { title: '사업참여신청서', required: true },
        { title: '자가진단표', required: true },
      ],
      loan: null,
      requestFiles: [],
    }
  },
  mounted() {
    this.ready = true
  },
  watch: {
    requestFileApplication: {
      deep: true,
      async handler(v) {
        if (v === false && this.isFileEditable) {
          await this.$router.replace(`${this.$route.path}/application`)
        }
      },
    },
  },
  async created() {
    this.$store.commit('ui/headerTitle', '우리동네크라우드펀딩신청현황')
    await this.fetchData()
  },
  computed: {
    isInvestingShow() {
      if (['investing', 'invested', 'executing'].includes(this.loan?.status)) {
        return true
      }
      return false
    },
    isFileEditable() {
      return !['reject', 'cancel'].includes(this.request?.status)
    },
    requestFileApplication() {
      return ['사업참여신청서', '자가진단표'].every(applicationTitle => {
        return this.requestFiles.find(f => f.title === applicationTitle)
      })
    }
  },
  methods: {
    async fetchData() {
      const { data } = await loansRequestApi.getLoansRequestDetail(this.uuid)
      this.request = data
    },
  },
}
</script>
